<template>
  <span class="flex items-center gap-1 cursor-pointer" @click="toggleLike(review.hasLiked, review.review_id)">
    <span class="text-[#9c9a9a] mt-1">{{ review.likes }}</span>
    <van-icon :name="$publicPath(`/images/${review?.hasLiked === 1 ? 'like' : 'unlike'}.svg`)" :size="14"/>
  </span>
</template>

<script setup>
import {useAuthStore} from "@/store/auth";
import {likeReview} from "@/plugins/API/review"
import {NOTIFICATION_ERROR_TYPES} from "~/constants";
import {useEventBus} from "@vueuse/core";
import {EVENTS, TRACKERS} from "~/constants/events";
import {track} from "~/composables/useTrackEvent";

const authStore = useAuthStore();
const {isLoggedIn} = storeToRefs(authStore);
const {emit: emitAuth} = useEventBus(EVENTS.AUTH_DIALOG);
const props = defineProps({
  review: {
    type: Object,
    default: {}
  },
  product: {
    type: Object,
    default: {}
  }
})
const likeStatus = ref('');

const toggleLike = (hasLiked, review_id) => {

  if (loading.value) return

  track(TRACKERS.REVIEW_LIKE_COMMENT, {
    type: 'like',
    product: props.product
  })
  if (isLoggedIn.value) {
    if (parseInt(hasLiked) === 0) {
      likeStatus.value = 1
    } else {
      likeStatus.value = 0
    }
    likeReviewComment(review_id)
  } else {
    emitAuth({redirection: false})
  }

}
const {isLoading: loading, mutateAsync: likeMutateAsync} = likeReview();
const likeReviewComment = (review_id, type = false) => {
  likeMutateAsync({review_id: review_id, like: likeStatus.value}).then(({data}) => {
    showNotification({
      type: NOTIFICATION_ERROR_TYPES.SUCCESS, messages: data.message
    });
    updateLike(likeStatus.value, review_id)
  });
}

const updateLike = (hasLiked, review_id) => {

  if (!review_id) return;

  // Convert likes to a valid number, fallback to 0 if invalid
  const currentLikes = parseInt(props.review.likes) || 0;

  props.review.likes = hasLiked === 1 ? currentLikes + 1 : currentLikes - 1;
  props.review.hasLiked = hasLiked === 1 ? 1 : 0;
}
</script>